import React, { useLayoutEffect, useRef, useMemo } from "react";
import { Canvas, Stage } from "react-scribble";
import { Box } from "./components/box";
import { Instructions } from "./components/instructions";
import { AnimatedValue } from "./animated-value";

export const App = () => {
  const ref = useRef();
  const scroll = useMemo(() => new AnimatedValue(0), []);

  useLayoutEffect(() => {
    const current = ref.current;
    const handler = (event) => {
      if (current) {
        scroll.setValue(current.scrollTop);
      }
    };
    current.addEventListener("scroll", handler);
    return () => current.removeEventListener("scroll", handler);
  }, [scroll]);
  return (
    <Canvas
      fps={60}
      loop={window.innerWidth > 600}
      width={window.innerWidth}
      height={window.innerHeight}
    >
      <Stage>
        <Box
          display="flex"
          flexDirection="column"
          flex={1}
          alignItems="center"
          css={{ overflowY: "scroll", width: "100%" }}
          ref={ref}
        >
          <Instructions scroll={scroll} />
        </Box>
      </Stage>
    </Canvas>
  );
};
